<script setup lang="ts">

</script>

<template>
  <div relative w-full overflow-hidden>
    <img src="/images/image-167-btc-1000.webp" max-h-393px max-h-956px w-full object-cover animated animated-slow style="animation-name: scale-in" alt="1000 BTC Cover">

    <div absolute inset-0 pt-37px text-center lg:hidden>
      <p class="lh-100%" text-12px font-bold uppercase>
        YOUR VOTE WILL DETERMINE
      </p>

      <h2 class="lh-100%" mt-20px text-35px font-bold uppercase>
        WHO WILL WIN
      </h2>
    </div>
  </div>
</template>

<style scoped>

</style>
